export default [
  { label: 'Name', name: 'name' },
  { label: 'Contact Number', name: 'contactNumber' },
  { label: 'Email', name: 'email' },
];